import { Reducer } from "redux"
import { AuthorizationState, AuthorizationActionTypes } from "./types";

// 初始化state
const initialState: AuthorizationState = {
  userInfo: {
    userId: "",
    realName: "",
    picture: "",
    gender: "",
    email: "",
    emailActive: "",
    mobile: "",
    mobileActive: ""
  },
  companyInfo: {
    companyId: "",
    companyLogo: "",
    name: "",
    userId: "",
    companyType: ""
  },
  configAppList: [],
  appList: [],
  permissionList: [],
  appInfo: {
    appId: "",
    appCode: "",
    appName: ""
  },
  menuList: [],
  commonMap: {},
  provinceList: [],
  errors: undefined,
  loading: false,
  projectSetting: {}
};

// 申请开票列表页面reducer定义
const reducer: Reducer<AuthorizationState> = (state = initialState, action) => {
  switch (action.type) {
    // 获取登陆用户信息
    case AuthorizationActionTypes.FETCH_USER_INFO: {
      return { ...state, loading: true };
    }
    case AuthorizationActionTypes.FETCH_USER_INFO_SUCCESS: {
      return {
        ...state,
        loading: false,
        userInfo: action.payload,
        companyInfo: action.payload.company ? action.payload.company: initialState.companyInfo
      };
    }
    case AuthorizationActionTypes.FETCH_USER_INFO_ERROR: {
      return {
        ...state,
        loading: false,
        errors: action.payload
      };
    }

    // 获取登陆用户当前应用所有权限
    case AuthorizationActionTypes.FETCH_USER_PERMISSION: {
      return { ...state, loading: true };
    }
    case AuthorizationActionTypes.FETCH_USER_PERMISSION_SUCCESS: {
      const permissionList = action.payload || [];
      return {
        ...state,
        loading: false,
        permissionList
      };
    }
    case AuthorizationActionTypes.FETCH_USER_PERMISSION_ERROR: {
      return {
        ...state,
        loading: false,
        errors: action.payload
      };
    }

    // 获取应用列表
    case AuthorizationActionTypes.FETCH_APP_LIST: {
      return { ...state, loading: true };
    }
    case AuthorizationActionTypes.FETCH_APP_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        appList: action.payload
      };
    }
    case AuthorizationActionTypes.FETCH_APP_LIST_ERROR: {
      return {
        ...state,
        loading: false,
        errors: action.payload
      };
    }

    // 获取用户配置权限列表（个人设置，公司设置等）
    case AuthorizationActionTypes.FETCH_CONFIG_APP_LIST: {
      return { ...state, loading: true };
    }
    case AuthorizationActionTypes.FETCH_CONFIG_APP_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        configAppList: action.payload || []
      };
    }
    case AuthorizationActionTypes.FETCH_CONFIG_APP_LIST_ERROR: {
      return {
        ...state,
        loading: false,
        errors: action.payload
      };
    }

    // 保存常用应用列表
    case AuthorizationActionTypes.FETCH_APP_SAVE: {
      return { ...state, loading: true };
    }
    case AuthorizationActionTypes.FETCH_APP_SAVE_SUCCESS: {
      return {
        ...state,
        loading: false
      };
    }
    case AuthorizationActionTypes.FETCH_APP_SAVE_ERROR: {
      return {
        ...state,
        loading: false,
        errors: action.payload
      };
    }

    // 获取菜单列表
    case AuthorizationActionTypes.FETCH_MENU_LIST: {
      return {
        ...state,
        appInfo: action.payload,
        loading: true
      };
    }
    case AuthorizationActionTypes.FETCH_MENU_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        menuList: action.payload
      };
    }
    case AuthorizationActionTypes.FETCH_MENU_LIST_ERROR: {
      return {
        ...state,
        loading: false,
        errors: action.payload
      };
    }

    // 获取公共数据字典
    case AuthorizationActionTypes.FETCH_COMMON_MAP: {
      return { ...state, loading: true };
    }
    case AuthorizationActionTypes.FETCH_COMMON_MAP_SUCCESS: {
      return {
        ...state,
        loading: false,
        commonMap: action.payload
      };
    }
    case AuthorizationActionTypes.FETCH_COMMON_MAP_ERROR: {
      return {
        ...state,
        loading: false,
        errors: action.payload
      };
    }

    // 登出
    case AuthorizationActionTypes.FETCH_LOGOUT: {
      return { ...state, loading: true };
    }
    case AuthorizationActionTypes.FETCH_LOGOUT_SUCCESS: {
      return {
        ...state,
        loading: false
      };
    }
    case AuthorizationActionTypes.FETCH_LOGOUT_ERROR: {
      return {
        ...state,
        loading: false,
        errors: action.payload
      };
    }

    // 获取省市信息
    case AuthorizationActionTypes.FETCH_PROVINCE_LIST: {
      return { ...state, loading: true };
    }
    case AuthorizationActionTypes.FETCH_PROVINCE_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        provinceList: action.payload
      };
    }
    case AuthorizationActionTypes.FETCH_PROVINCE_LIST_ERROR: {
      return {
        ...state,
        loading: false,
        errors: action.payload
      };
    }

    // 获取省市信息
    case AuthorizationActionTypes.FETCH_GET_PROJECT_SETTING: {
      return { ...state, loading: true };
    }
    case AuthorizationActionTypes.FETCH_GET_PROJECT_SETTING_SUCCESS: {
      return {
        ...state,
        loading: false,
        projectSetting: action.payload
      };
    }
    case AuthorizationActionTypes.FETCH_GET_PROJECT_SETTING_ERROR: {
      return {
        ...state,
        loading: false,
        errors: action.payload
      };
    }

    default: {
      return state;
    }
  }
}

export { reducer as authorizationReducer }
